import Alert from 'assets/images/alert.svg'
import { CeruleanButton, GrayButton } from 'components/Button'
import I18n from 'components/I18n'
import { OverlayLoader } from 'components/Loaders'
import { actions } from 'data'
import { Bank } from 'data/Payments/BankTransfer/types'
import messages from 'lang'
import React, { useCallback, useEffect } from 'react'
import { MessageDescriptor } from 'react-intl'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { Header, ModalTitle, Wrapper } from '../styles'

type BankSettlementProps = {
  bank?: Bank
  message: MessageDescriptor
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>
  settlementResponse: any
}

const StyledWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const AlertIcon = styled.img`
  height: 40px;
`

const ContentTopWrapper = styled.div`
  display: grid;
  grid-auto-rows: min-content;
  gap: 1.5rem;
  justify-items: center;
`

const BtnActionsWrapper = styled.div`
  display: grid;
  grid-auto-rows: min-content;
  gap: 0.5rem;
`

const StyledHeader = styled(Header)`
  margin-bottom: 0;
`

const MessageWrapper = styled.div`
  text-align: center;
  line-height: 150%;
`

const Footer = styled.div`
  display: flex;

  > * {
    flex: 1;
  }
`

const BankSettlement = ({ bank, message, setRefresh, settlementResponse }: BankSettlementProps) => {
  const dispatch = useDispatch()

  const clearBankSettlement = useCallback(() => {
    dispatch(actions.payments.clearBankSettlement())
  }, [])

  const submitDeposit = useCallback(() => {
    if (!bank) return null
    dispatch(
      actions.payments.submitDeposit.submitDeposit(settlementResponse.amount, bank.currency, bank)
    )
  }, [bank])

  useEffect(() => {
    return () => {
      dispatch(actions.payments.clearBankSettlement())
    }
  }, [])

  if (!settlementResponse || !bank) return <OverlayLoader />

  return (
    <StyledWrapper>
      <ContentTopWrapper>
        <AlertIcon src={Alert} />
        <StyledHeader>
          <ModalTitle>
            <I18n
              data={
                settlementResponse.settlementType === 'REGULAR'
                  ? messages.label_confirm_deposit
                  : messages.label_deposit_failed
              }
            />
          </ModalTitle>
        </StyledHeader>
        <MessageWrapper>
          <I18n data={message} />
        </MessageWrapper>
      </ContentTopWrapper>
      <Footer>
        <BtnActionsWrapper>
          {settlementResponse.reason === 'REQUIRES_UPDATE' && (
            <CeruleanButton
              onClick={() => {
                dispatch(actions.payments.fetchBankLinkTokenForRefresh(bank.id))
                clearBankSettlement()
                setRefresh(true)
              }}
            >
              <I18n data={messages.relink_bank} />
            </CeruleanButton>
          )}
          {settlementResponse.reason === 'REQUIRES_UPDATE' &&
          settlementResponse.settlementType === 'UNAVAILABLE' ? null : settlementResponse.reason !==
              'REQUIRES_UPDATE' && settlementResponse.settlementType === 'UNAVAILABLE' ? (
            <CeruleanButton onClick={clearBankSettlement}>
              <I18n data={messages.okay} />
            </CeruleanButton>
          ) : (
            <GrayButton onClick={submitDeposit}>
              <I18n data={messages.button_continue} />
            </GrayButton>
          )}
        </BtnActionsWrapper>
      </Footer>
    </StyledWrapper>
  )
}

export default BankSettlement
